// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__UtnxA","inputWrap":"CustomTip_inputWrap__3SeE_"};